module.exports = __webpack_public_path__ + "static/media/ukiyo.2bd156f3.svg";